/**
 * /tenants/$slug/agents/$agentId/policy — full-page consequence-policy editor shim.
 * Reuses the detail loader so the agent is warm in cache before the page renders.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchAgent } from "@/features/agents/queries";
import { queryKeys } from "@/lib/query-keys";
import { AgentPolicyEditorPage } from "@/features/agents/pages/agent-policy-editor-page";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/$agentId/policy")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.agents.detail(context.tenant.id, params.agentId),
      queryFn: () => fetchAgent(context.tenant.id, params.agentId),
    }),
  component: AgentPolicyEditorPage,
});
